import script from "./ShoppingBagIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingBagIcon.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingBagIcon.vue?vue&type=style&index=0&id=c4990af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4990af2"]])

export default __exports__